import React, { useContext, useEffect, useMemo } from "react";

import { StyleSheetManager } from "styled-components";
import { StylesProvider, createGenerateClassName } from "@mui/styles";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import { CacheProvider } from "@emotion/react";

import { prefixer } from "stylis";

import createCache from "@emotion/cache";

import rtlPlugin from "stylis-plugin-rtl";

import { faIR } from "@mui/material/locale";

import { CustomThemeContext } from "common/context/customTheme/customThemeContext";

const generate_ClassName = createGenerateClassName({
  seed: "Geradian",
});

function RTL(props) {
  return (
    <StyleSheetManager stylisPlugins={[rtlPlugin]}>
      {props.children}
    </StyleSheetManager>
  );
}

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export function MaterialThemeProvider(props) {
  const { children } = props;
  const { currentTheme } = useContext(CustomThemeContext);
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--color-primary", currentTheme.colors.primary);
    root.style.setProperty("--color-secondary", currentTheme.colors.secondary);
    root.style.setProperty("--color-accent", currentTheme.colors.accent);
    root.style.setProperty("--color-surface", currentTheme.colors.surface);
    root.style.setProperty(
      "--color-background",
      currentTheme.colors.background,
    );
    root.style.setProperty("--color-border", currentTheme.colors.border);
    root.style.setProperty(
      "--color-text-primary",
      currentTheme.colors.text.primary,
    );
    root.style.setProperty(
      "--color-text-secondary",
      currentTheme.colors.text.secondary,
    );
    root.style.setProperty(
      "--color-disabled-background",
      currentTheme.colors.disabledBackground,
    );
    root.style.setProperty(
      "--color-disabled-text",
      currentTheme.colors.disabledText,
    );
    root.style.setProperty("--color-divider", currentTheme.colors.border);
    root.style.setProperty(
      "--color-text-muted",
      currentTheme.colors.text.muted,
    );
    root.style.setProperty(
      "--color-surface-alt",
      currentTheme.colors.surfaceAlt,
    );
  }, [currentTheme]);

  const theme = useMemo(() => {
    return createTheme(
      {
        direction: "rtl",

        typography: {
          fontFamily: ["IRANSansWeb_Farsi"].join(","),
        },

        palette: {
          primary: {
            main: currentTheme.colors.primary,
            light: currentTheme.colors.primaryLight,
            dark: currentTheme.colors.primaryDark,
            contrastText: currentTheme.colors.text.inverse,
          },
          secondary: {
            main: currentTheme.colors.secondary,
          },
          background: {
            default: currentTheme.colors.background,
            paper: currentTheme.colors.surfaceAlt,
          },
          text: {
            primary: currentTheme.colors.text.primary,
            secondary: currentTheme.colors.text.secondary,
            disabled: currentTheme.colors.disabledText,
          },
          action: {
            disabledBackground: currentTheme.colors.disabledBackground,
            disabled: currentTheme.colors.disabledText,
          },
          error: { main: currentTheme.colors.error },
          warning: { main: currentTheme.colors.warning },
          success: { main: currentTheme.colors.success },
          info: { main: currentTheme.colors.info },
        },
        components: {
          MuiButtonBase: {
            defaultProps: {
              disableRipple: false,
            },
          },

          MuiPopover: {
            defaultProps: {
              elevation: 1,
            },
          },
        },
      },

      faIR,
    );
  }, [currentTheme]);

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <RTL>
          <StylesProvider generateClassName={generate_ClassName}>
            {children}
          </StylesProvider>
        </RTL>
      </ThemeProvider>
    </CacheProvider>
  );
}
